<template>
  <v-container>
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="8" class="pa-2">
        <LastMatchdayGamesWidget
          :seasonId="currentUser.league.seasonId"
          @heightChange="lastMatchdayGameHeight=$event"
        ></LastMatchdayGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <LastPlayersSearch class="mt-3" v-bind:style="{'height':lastMatchdayGameHeight+'px'}"></LastPlayersSearch>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2">
        <NextMatchdayGamesWidget
          :seasonId="currentUser.league.seasonId"
          @heightChange="nextMatchdayHeight = $event"
        ></NextMatchdayGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <FavoritesWidget
          :userId="currentUser.id"
          class="mt-3"
          v-bind:style="{'height':nextMatchdayHeight+'px'}"
        ></FavoritesWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="mt-3 elevation-2"
          :slides="['playerScoutChart','playerReportsChart']"
          @heightChange="chartsHeight=$event"
        ></ChartsWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <CollectionsWidget class="mt-3"
        v-bind:style="{'height':chartsHeight+'px'}"></CollectionsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LastMatchdayGamesWidget from "./widgets/LastMatchdayGamesWidget";
import FavoritesWidget from "./widgets/FavoritesWidget";
import CollectionsWidget from "./widgets/CollectionsWidget";
import LastPlayersSearch from "./widgets/LastPlayersSearch";
import NextMatchdayGamesWidget from './widgets/NextMatchdayGamesWidget';
import ChartsWidget from './widgets/ChartsWidget';
import { userHasRole } from "../../utils/functions";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "IndividualDashboard",
  props: {
  },
  components: {
    LastMatchdayGamesWidget,
    LastPlayersSearch,
    FavoritesWidget,
    CollectionsWidget,
    NextMatchdayGamesWidget,
    ChartsWidget,
    LastScoutingAnalysesWidget,
    ScoutingTasksWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  data() {
    return{
      loading: false,
      lastMatchdayGameHeight: null,
      nextMatchdayHeight:null,
      chartsHeight: null
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted()  {
    this.loadViewData();
  },
  methods: {
    loadViewData() {},
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/IndividualDashboard.vue